import Terry from '../Assets/staff-terry-grainger.jpg'
import Ingrid from '../Assets/staff-ingrid-doyle.jpg'
import Tee from '../Assets/staff-tee-duong.jpg'
import Matthew from '../Assets/staff-matthew-grainger.jpg'

function getStaffPhoto(name) {
  switch (name) {
    case 'Terry Grainger':
      return Terry;

    case 'Ingrid de Chélard':
      return Ingrid;

    case 'Tee Duong':
      return Tee;

    case 'Matthew Grainger':
      return Matthew;

    default:
      return null;
  }
}

export { getStaffPhoto };